export const common = {
  nav_home: 'Inicio',
  nav_quiz: 'Hacer el Cuestionario',
  nav_decision_tree: '\u00C1rbol de Decisiones',
  nav_about: 'Acerca de',
  nav_contact: 'Contacto',
  nav_cta: 'Hacer el Cuestionario',
  lang_en: 'EN',
  lang_es: 'ES',
  footer_tagline: 'Comun\u00EDquese con claridad. Maneje conflictos con confianza. Lidere con autoridad tranquila.',
  footer_quick_links: 'Enlaces R\u00E1pidos',
  footer_resources: 'Recursos',
  footer_contact: 'Contacto',
  footer_copyright: '\u00A9 {year} Calm Authority. Todos los derechos reservados. Materials, resources and course content may not be reproduced, distributed or shared without written permission.',
};